import { makeAutoObservable } from 'mobx'

class GeneralStore {
    constructor() {
        makeAutoObservable(this)
    }

    getInitials = (name) => {
        const names = name.split(' ');
        const initials = names.map((n) => n.charAt(0).toUpperCase()).join('');
        return initials;
    };

}

const generalStore = new GeneralStore();
export default generalStore